// extracted by mini-css-extract-plugin
export default {"contentBox":"Exercise_contentBox__lZHWW","removePadding":"Exercise_removePadding__YHTL2","content":"Exercise_content__Ka6r6","sidebar":"Exercise_sidebar__qch1d"};